var _path, _path2, _line, _line2, _line3, _polyline;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIndoorBaggageClaim(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42 42",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m15.772,33.054H7.594c-2.26,0-4.091-1.832-4.091-4.091v-15.224c0-2.26,1.832-4.091,4.091-4.091h26.813c2.26,0,4.091,1.832,4.091,4.091v15.224c0,2.26-1.832,4.091-4.091,4.091h-8.414"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.81,5.787h2.38c2.131,0,3.861,1.73,3.861,3.861h-10.101c0-2.131,1.73-3.861,3.861-3.861Z"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 10.276,
    y1: 9.648,
    x2: 10.276,
    y2: 33.054
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 31.724,
    y1: 9.648,
    x2: 31.724,
    y2: 33.054
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 21,
    y1: 18.628,
    x2: 21,
    y2: 36.213
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "16.448 23.189 21.009 18.628 25.552 23.172"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndoorBaggageClaim);
export default __webpack_public_path__ + "static/media/indoor-baggage_claim.000d3a3c202969ce3bdeda8e4a4d3421.svg";
export { ForwardRef as ReactComponent };